import { createStore } from 'vuex';

import calendar from './modules/calendar';

export default createStore({
  modules: {
    calendar,
  },
  strict: true,
});
